import { Text } from 'domains/reporter/RichTextEditor/core';
import type { MarkPluginID } from '../plugins/types';

import styled from 'styled-components';
import type { RendererRenderText } from './types';
import forEachObjIndexed from 'ramda/es/forEachObjIndexed';
import { getSourceTextColor } from '../plugins/textSourceStyling/utils';

export type TextComponentProps = Readonly<{
  node: Text;
  renderText: RendererRenderText;
}>;

const StyledText = styled.span`
  /* Make sure empty content still renders line height of element */
  &::before {
    content: '\u{200b}'; // unicode zero width space character
  }

  ${({ source }: { source?: string }) => {
    return `color: ${getSourceTextColor(source)};`;
  }}
`;

export const TextComponent = ({ node, renderText }: TextComponentProps): React.ReactNode => {
  const { text, ...marks } = node;
  const attributes = { 'data-slate-leaf': true } as const;
  const leaf: Text = { text, ...marks };
  let children: React.ReactNode = <StyledText {...attributes}>{text}</StyledText>;

  forEachObjIndexed((_val: any, mark: MarkPluginID) => {
    children = renderText({ mark, children, leaf, text: leaf, attributes });
  }, marks);

  return children;
};
